import React from 'react';
import PropTypes from 'prop-types';
import FirstWOLoad from "./FirstWOLoad"
import  useLoading  from '../hooks/useLoading';

const Loading = (props) => {
  const {isLoading, isFirstWOLoad} = useLoading();

  return isLoading ? (
    <div className="spinner-container">
    {isFirstWOLoad? <FirstWOLoad/> : <>    
    <h1 className="loading-text">Loading</h1>
     </>}
     <div className="spinner-inner-container">
      <div className="spinner" />
    </div>
  </div>
    
  ) 
  : null;
}
export default Loading;

Loading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};
